import React from 'react';
import { ReactComponent as CloseIcon } from './icons/Close.svg';
import './styles/ChecadorStyles.css';

const DialogUnitsList = ({
  dialogUnitsList,
  closeDialogUnitsList,
}) => {
  const dialogStripeOpen = dialogUnitsList?.open ?? false;
  const checkerName = dialogUnitsList?.checkerName ?? '';
  const dateValue = dialogUnitsList?.dateValue ?? '';
  const dateTimeFormat = new Intl.DateTimeFormat('es-MX', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const dateDisplay = dateTimeFormat.format(dateValue);
  const unitsList = dialogUnitsList?.unitsList ?? [];
  const unitsCount = unitsList?.length ?? 0;
  if (dialogStripeOpen) {
    return (
      <div className="dialog-background" onClick={closeDialogUnitsList} role="dialog">
        <div className="dialog-units-list" onClick={(e) => e.stopPropagation()} role="dialog">
          <div className="dialog-header">
            <h5 className="dialog-title">Checadas del día por unidad</h5>
            <button
              type="button"
              className="close-button"
              onClick={closeDialogUnitsList}
            >
              <span className="close-button-label">
                <svg className="close-button-svg">
                  <CloseIcon className="close-icon" />
                </svg>
              </span>
            </button>
          </div>
          <div className="dialog-body">
            <fieldset className="units-info-form">
              <legend className="units-info-legend">Información general</legend>
              <div className="units-info-container">
                <div className="checker-input-container">
                  <label className="checker-label" htmlFor="checker-units-info">
                    Checador
                    <input
                      value={checkerName}
                      type="text"
                      readOnly
                      id="checker-units-info"
                      name="checker-units-info"
                      className="checker-units-info"
                    />
                  </label>
                </div>
                <div className="date-input-container">
                  <label className="date-label" htmlFor="date-units-info">
                    Fecha
                    <input
                      value={dateDisplay}
                      type="text"
                      readOnly
                      id="date-units-info"
                      name="date-units-info"
                      className="date-units-info"
                    />
                  </label>
                </div>
                <div className="count-input-container">
                  <label className="count-label" htmlFor="count-units-info">
                    # Unidades
                    <input
                      value={unitsCount}
                      type="text"
                      readOnly
                      id="count-units-info"
                      name="count-units-info"
                      className="count-units-info"
                    />
                  </label>
                </div>
              </div>
            </fieldset>
            <fieldset className="units-list-form">
              <legend className="units-list-legend">Unidades</legend>
              <div className="ul-units-container">
                <ul className="ul-units-list">
                  {unitsList.map((item) => (
                    <li className="li-unit-item" key={`li-item-${item.idUnidad}`}>{item.unidad}</li>
                  ))}
                </ul>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default DialogUnitsList;
